export default __webpack_public_path__ + "static/media/dialingSound.21e4ce53.mp3";